<template>
    <div class="row">
        <div class="col">
            <sub-section title="Risk warnings" :showHelp="false">
                <p v-for="(warning, i) in htmlArray('disclaimers.risk-warnings')" :key="i" v-html="warning"></p>
            </sub-section>
        </div>
    </div>
</template>

<script setup lang="ts">
import SubSection from '../common/SubSection.vue';
import { useUIContent } from '@/guiide/ts/configuration/useUIContent';

const { htmlArray } = useUIContent();

</script>
